import Spinner from 'components/Common/Spinner';
import Grid from '@mui/material/Grid2';
import { Box, Button, Typography } from '@mui/material';
import Search from 'components/Common/Search';
import { useGetAvailableIntegrations } from 'apis/agency/integrations/hook';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Integrations() {
  const [searchText, setSearchText] = useState<null | string>(null);
  const { data: availableIntegrations, isLoading } = useGetAvailableIntegrations();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Box display='flex' justifyContent='space-between'>
        <Box>
          <Typography variant='h5' fontWeight={500} mb={1}>
            Integrations
          </Typography>
          <Typography color='secondary' fontSize={14}>
            Seamlessly connecting your systems to enhance efficiency and streamline workflows. Simplify processes and
            boost productivity with ease.
          </Typography>
        </Box>
        <Search size='small' placeholder='Search' setSearchText={setSearchText} searchText={searchText} />
      </Box>
      <Grid container spacing={2} mt={3}>
        {availableIntegrations?.data?.map((item, index) => (
          <Grid
            key={index}
            size={{ xs: 12, md: 6, lg: 4 }}
            bgcolor='white'
            p={2}
            border='1px solid #ECECEC'
            borderRadius={2}
          >
            <img src={item.avatar_url} alt={item.name} style={{ maxHeight: 30 }} />
            <Typography my={1} color='secondary' fontSize={14}>
              {item.description}
            </Typography>
            <Box display='flex' justifyContent='end'>
              <Link to={String(item.id)}>
                <Button>Read & Configure</Button>
              </Link>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
